import React, { useState, useEffect, useContext } from "react";
import { Api, Api_Token, updateAuthToken } from "../util/Api";
import Cookies from "js-cookie";
import { useNavigate } from "react-router";

const AuthContext = React.createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const Navigate = useNavigate();

  useEffect(() => {
    Api_Token.get("user")
      .then((response) => {
        setUser(response.data);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);
  const login = (email, password) => {
    Api.post("auth/login", { email, password })
      .then((response) => {
        Cookies.set("token", response.data.token);
        updateAuthToken(response.data.token);
        setUser(response.data.user);
        if (response.data.user.Role === "admin") {
          Navigate(`/dashboard`);
        } else {
          Navigate("/dashboard-user");
        }
      })
      .catch((error) => {
        console.error("Login failed:", error);
      });
  };

  const logout = async () => {
    setUser(null);
    Cookies.remove("token");
  };

  const value = { user, login, logout };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
}
